import React, {useEffect, useState} from "react";
import MyTopAppBar from "./header/navbar";
import {Routes} from "../../routes";
import {Footer} from "./my-footer";
import Grid from "@mui/material/Grid";
import {Auth, Logger} from "aws-amplify";
import {AuthService} from "../../screens/auth/service/auth-service";
import {Hub} from "@aws-amplify/core";
import FloatingActionButtonZoom from "../../screens/uploads/upload-floating-button";
import useMediaQuery from "@mui/material/useMediaQuery";
import {useTheme} from "@mui/material/styles";
import {Link} from "react-router-dom";
import Button from "@mui/material/Button";
import {
    BottomNavigation, BottomNavigationAction,
    Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle,
    List, ListItem, ListItemText, Paper
} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import FolderIcon from '@mui/icons-material/Folder';

const logger = new Logger('FullLayout');

const UploadDialog = ({open, onClose}) => (
    <Dialog open={open} onClose={onClose} PaperProps={{ sx: { borderRadius: 3 } }}>
        <DialogTitle>Upload Document</DialogTitle>
        <DialogContent>
            <DialogContentText>Choose the type of document you want to upload.</DialogContentText>
            <List>
                {[{name: 'Upload Receipt', linkTo: '/upload-receipt'}, {name: 'Upload Bank Statement', linkTo: '/upload-findoc'}].map(b => (
                    <ListItem button component={Link} to={b.linkTo} onClick={onClose} key={b.name}
                        sx={{ borderRadius: 2, mb: 0.5, '&:hover': { background: 'rgba(99,102,241,0.06)' } }}>
                        <ListItemText primary={b.name}/>
                    </ListItem>
                ))}
            </List>
        </DialogContent>
        <DialogActions><Button onClick={onClose}>Cancel</Button></DialogActions>
    </Dialog>
);

export function FullLayout() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [loggedInUser, setLoggedInUser] = useState({});
    const [uploadDialogOpen, setUploadDialogOpen] = useState(false);
    const [value, setValue] = useState('projects');
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        const onHubCapsule = ({channel, payload}) => {
            if (channel === AuthService.CHANNEL) {
                if (payload.event === AuthService.AUTH_EVENTS.LOGIN && payload.success) setLoggedIn(true);
                if (payload.event === AuthService.AUTH_EVENTS.SIGN_OUT && payload.success) setLoggedIn(false);
            }
        };
        Hub.listen(AuthService.CHANNEL, onHubCapsule);
        Auth.currentAuthenticatedUser({bypassCache: true})
            .then(user => { setLoggedIn(true); setLoggedInUser(user); })
            .catch(() => { setLoggedIn(false); setLoggedInUser({}); });
        return () => Hub.remove(AuthService.CHANNEL, onHubCapsule);
    }, []);

    return (
        <div style={{ minHeight: '100vh', background: '#F8FAFC', paddingBottom: isMobile ? 72 : 0 }}>
            {isMobile && (
                <Paper sx={{ position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 1200,
                    borderTop: '1px solid rgba(0,0,0,0.06)', borderRadius: 0 }} elevation={0}>
                    <BottomNavigation showLabels value={value}
                        onChange={(e, v) => v === 'upload' ? setUploadDialogOpen(true) : setValue(v)}
                        sx={{ background: 'rgba(255,255,255,0.9)', backdropFilter: 'blur(20px)' }}>
                        <BottomNavigationAction component={Link} to="/projects" label="Projects" value="projects" icon={<FolderIcon/>}/>
                        <BottomNavigationAction label="Upload" value="upload" icon={<AddIcon/>}/>
                    </BottomNavigation>
                </Paper>
            )}
            <Grid container justifyContent="flex-start" style={{width: "100%"}}>
                <Grid item xs={12}><MyTopAppBar loggedIn={loggedIn} loggedInUser={loggedInUser}/></Grid>
                <Grid item xs={12} sx={{ minHeight: 'calc(100vh - 180px)' }}><Routes/></Grid>
                {!isMobile && <FloatingActionButtonZoom/>}
                <Grid item xs={12}><Footer/></Grid>
            </Grid>
            <UploadDialog open={uploadDialogOpen} onClose={() => setUploadDialogOpen(false)}/>
        </div>
    );
}
